import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const appStore = new Vuex.Store({
  state: {
    subMenuItems: [],
    isAdmin: false
  },
  getters: {
    subMenuItems(state) {
      return state.subMenuItems
    },
    hidden(state) {
      return state.hidden
    },
    isAdmin(state){
      return state.isAdmin
    }
  },
  mutations: {
    set(state, {type, items}) {
      state[type] = items
    }
  },
  actions: {
    pushSubMenuItems({commit}, data) {
      commit('set', {type: 'subMenuItems', items: data})
    },

    hide({commit}, data) {
      commit('set', {type: 'hidden', items: true})
    },
    show({commit}, data) {
      commit('set', {type: 'hidden', items: false})
    },
    setAdmin({commit}, data) {
      console.log("setAdmin = ", data)
      commit('set', {type: 'isAdmin', items: data})
    }
  }
})
export default appStore

/*
import Vue from 'vue'
import Vuex from 'vuex'
import dispatchActionForAllModules from '@utils/dispatch-action-for-all-modules'

import modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
})

export default store

// Automatically run the `init` action for every module,
// if one exists.
dispatchActionForAllModules('init')
*/
